import { useEffect, useRef } from "react";
import { registerEscape } from "../utils/escapeStack";

// Closes the active modal when the user presses Escape.
// `active` defaults to true; pass a boolean (e.g. `show`) to only listen while open.
export default function useEscapeKey(onClose, active = true) {
  const handlerRef = useRef(onClose);
  handlerRef.current = onClose;

  useEffect(() => {
    if (!active) return undefined;
    const unregister = registerEscape(() => {
      if (handlerRef.current) handlerRef.current();
    });
    return unregister;
  }, [active]);
}
